import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { user_login } from '../../redux/actions/userAuthActions'

import project_bg from '../../assets/ww.png'
import '../../styles/modalForm.css'

const Login = () => {
	const dispatch = useDispatch()

	const navigate = useNavigate()

	const userAuth = useSelector((state) => state.userAuth)
	const { loading, userDetail } = userAuth

	const [inputText, setInputText] = useState('')
	const [password, setPassword] = useState('')

	const loginSubmitHandler = (e) => {
		e.preventDefault()
		dispatch(user_login(inputText, password))
	}

	const viewHandler = () => {
		let pass = document.getElementById('password')
		let view = document.getElementById('view')
		let view2 = document.getElementById('view2')
		const type = pass.getAttribute('type') === 'password' ? 'text' : 'password'
		pass.setAttribute('type', type)

		view.classList.toggle('fa-eye-slash')
	}

	useEffect(() => {
		if (userDetail) {
			navigate('/user/dashboard/home')
		}
	}, [userDetail])

	return (
		<>
			<section style={{ background: `url(${project_bg})` }} className='login'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-md-5'>
							<div className='login_form'>
								<h4 className='text-center'>
									{' '}
									<strong>SIGN IN</strong>{' '}
								</h4>
								<form className='' onSubmit={loginSubmitHandler}>
									<label className='label'>Email or Mobile</label>
									<input
										type='text'
										value={inputText}
										className='form-control mb-3'
										onChange={(e) => setInputText(e.target.value)}
									/>
									<label className='label'>Password</label>
									<div style={{ position: 'relative' }}>
										<input
											type='password'
											id='password'
											value={password}
											className='form-control mb-1'
											onChange={(e) => setPassword(e.target.value)}
										/>
										<i
											className='fa fa-eye view'
											id='view'
											onClick={viewHandler}
										></i>
									</div>
									<p className='reset'>
										Forgot Password? <Link to='#'>Reset here</Link>{' '}
									</p>
									<input type='checkbox' name='' id='' />{' '}
									<span>Remember me</span>
									<div className='text-center'>
										<button
											className='form-control modal_btn'
											disabled={
												inputText && password && !loading ? false : true
											}
										>
											{loading ? (
												<i className='fas fa-spinner fa-spin'></i>
											) : (
												<span className='text-white'>Login</span>
											)}
										</button>
									</div>
									<p className='reset text-center'>
										You don't have an account?{' '}
										<Link to='/register'>Register here</Link>
									</p>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default Login
